import React, { Component } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import Bio from "../models/bio";
import BioComponent from "../components/bio";
import BioIndexComponent from "../components/bio-index";
import ContactComponent from "../components/contact";
import EntertainmentComponent from "../components/entertainment";
import Footer from "../components/footer";
//Components imports
import HeaderComponent from "../components/header";
import MMps from "../models/mmps";
import MMpsComponent from "../components/mmps";
import MillenialsComponent from "../components/millenials";
import Partners from "../components/partners";
import RouterHOC from "../hoc/RouterHOC";
import VideoComponent from "../components/videos";
import ViewEntertainmentComponent from "../components/view-entertainment";
import ViewMillenialsComponent from "../components/view-millenials";
import ViewVideoComponent from "../components/view-video";
import ViewpartnerComponent from "../components/view-partner";
import { connect } from "react-redux";
import header2Banner from "../img/header-2-background.png";
//Images imports
import headerBanner from "../img/header-background-v2.png";

/**
 * Route Definitions and full page Layout
 */
class Routes extends Component {
  render() {
    const { languagePack, data } = this.props;
    console.log(languagePack);
    return (
      <Router>
        <div>
          <HeaderComponent menuList={Object.values(languagePack.menu)} />
          <Switch>
            <Route path="/" exact>
              <div>
                <EntertainmentComponent
                  sizes={{ 0: 2, 768: 2, 992: 3 }}
                  colSize={2}
                  list={Object.values(data.projects)}
                />
              </div>
            </Route>
            <Route path="/projetos" exact>
              <EntertainmentComponent
                sizes={{ 0: 2, 768: 2, 992: 4 }}
                list={Object.values(data.projects)}
              />
            </Route>
            <Route
              path="/projetos/:id/:name"
              render={(props) => (
                <ViewEntertainmentComponent
                  list={Object.values(data.projects)}
                  {...props}
                />
              )}
            />
            <Route path="/parceiros" exact>
              <Partners
                sizes={{ 0: 2, 768: 2, 992: 4 }}
                list={Object.values(data.partners)}
              />
            </Route>
            <Route
              path="/parceiros/:id/:name"
              render={(props) => (
                <ViewpartnerComponent
                  list={Object.values(data.partners)}
                  {...props}
                />
              )}
            />
            <Route path="/bio">
              <BioComponent
                banner={headerBanner}
                list={Object.values(data.bios)}
              />
            </Route>
            <Route path="/contato">
              <ContactComponent
                banner={headerBanner}
                contact={languagePack.contact}
                form={languagePack.contact_form}
              />
            </Route>

            <Redirect from="*" to="/" />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}

const RoutesConnected = (state) => {
  return {
    languagePack: state.languagePack,
    data: state.data,
  };
};

export default connect(RoutesConnected)(RouterHOC(Routes));



// WEBPACK FOOTER //
// ./src/config/routes.js